import {useQuery} from '@tanstack/react-query';
import {queryClient} from '@/utils/reactQueryClient';
import {Message} from '@/api/messages/types';
import {
  fetchVersionMessages,
  mergePendingMessages,
  versionMessagesQueryKey,
} from '@/api/messages';
import {MESSAGES_POLL_INTERVAL_MS} from '@/api/messages/constants';

export default function useVersionMessagesQuery(
  versionId: string | null,
  {
    enabled = true,
    pollIntervalMs = MESSAGES_POLL_INTERVAL_MS,
  }: {enabled?: boolean; pollIntervalMs?: number} = {}
) {
  const isEnabled = enabled && Boolean(versionId);
  const queryKey = versionMessagesQueryKey(versionId ?? '');
  const {data, isLoading, isError, error, refetch, isFetching} = useQuery({
    queryKey,
    queryFn: async () => {
      const fetched = await fetchVersionMessages(versionId as string);
      const previous = queryClient.getQueryData<Message[]>(queryKey) ?? [];
      return mergePendingMessages(fetched, previous);
    },
    enabled: isEnabled,
    refetchInterval: isEnabled ? pollIntervalMs : false,
    refetchOnWindowFocus: true,
  });

  return {
    messages: data ?? [],
    isLoading: isEnabled && isLoading,
    isError,
    error,
    refetch,
    isFetching,
  };
}
